import * as Yup from "yup";

export const addvalidationSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required!"),
  last_name: Yup.string().required("Last name is required!"),
  email: Yup.string().email("Invalid email format!").required("Email is required!"),
  mobile_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile no must be 10 digits!")
    .required("Mobile number is required!"),
  password: Yup.string()
    .required("Password is required!")
    .min(6, "Password length at least 6.")
    .matches(/[0-9]/, "Password requires a number")
    .matches(/[a-z]/, "Password requires a lowercase letter")
    .matches(/[A-Z]/, "Password requires an uppercase letter")
    .matches(/[^\w]/, "Password requires a special character"),
  confirm_password: Yup.string()
    .required("Confirm password is required!")
    .oneOf([Yup.ref("password"), null], "Confirm password must be the same as the password"),
  role_id: Yup.string().required("Role is required!"),
  image: Yup.string().required("Image is required!"),
  is_active: Yup.string().required("Status is required!"),
});

export const editvalidationSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required!"),
  last_name: Yup.string().required("Last name is required!"),
  email: Yup.string().email("Invalid email format!").required("Email is required!"),
  mobile_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile no must be 10 digits!")
    .required("Mobile number is required!"),
  role_id: Yup.string().required("Role is required!"),
  image: Yup.string().required("Image is required!"),
  is_active: Yup.string().required("Status is required!"),
});
